import { round } from "lodash";
import React, {Component} from "react";
import {AppRow} from "../components/components";

const roundNumber = (num) => {
	return Math.round((num + Number.EPSILON) * 100) / 100
}
class FdaDetails extends Component {

	constructor(props) {
		super(props);
	}
	
	render() {
        let {focusTestMap} = this.props;
		if(focusTestMap) {
			return <div align={"right"}>
				<AppRow title={"Mean F-Error(%)"}
					value={roundNumber(focusTestMap['summary']["f_error"]['mean'])}/>
				<AppRow title={"Median F-Error(%)"}
					value={roundNumber(focusTestMap['summary']["f_error"]['median'])}/>
				<AppRow title={"Mean Z Diff(um)"}
					value={roundNumber(focusTestMap['summary']["z_diff"]['mean'])}/>
				<AppRow title={"Median Z Diff(um)"}
					value={roundNumber(focusTestMap['summary']["z_diff"]['median'])}/>
				<AppRow title={"Mean Overlap(%)"}
					value={roundNumber(focusTestMap['summary']["overlap"]['mean'])}/>
				<AppRow title={"Median Overlap"}
					value={roundNumber(focusTestMap['summary']["overlap"]['median'])}/>
			</div>
		} else {
			return <div align={"right"}></div>
		}
	}
}

export default FdaDetails;
